import Request from '@/requests/Request'
const resource = "/logica-intervencoes/{logicaIntervencaoId}/indicadores";

export default {
  findAll() {
    return Request.get(`${resource}`)
  },
  findById(indicadorId) {
    return Request.get(`${resource}/${indicadorId}`)
  },
  findByParentId (logicaIntervencaoId) {
    const url = resource.replace(new RegExp("{logicaIntervencaoId}", "g"), logicaIntervencaoId)
    return Request.get(`${url}`)
  },
  findItemsParentId(id) {
    return Request.get(`${resource}/fontes/`+ id)
  },
  
  post(logicaIntervencaoId, indicador) {
    const url = resource.replace(new RegExp("{logicaIntervencaoId}", "g"), logicaIntervencaoId)
    return Request.post(`${url}`, indicador)
  },
  put(id, indicador) {
    return Request.put(`${resource}/logica-intervencao/` + id, indicador)
  },
  putProgresso(id, progresso) {
    const form = new FormData();
    form.append('progresso', progresso);
    return Request.put(`${resource}/${id}/progresso/`, form)
  },

  delete(indicador) {
    return Request.delete(`${resource}/${indicador}`);
  },

  adicionarSubindicador(logicaIntervencaoId, indicadorPaiId, indicadorFilhoId) {
    const url = resource.replace(new RegExp("{logicaIntervencaoId}", "g"), logicaIntervencaoId)
    return Request.put(`${url}/${indicadorPaiId}/subindicador/${indicadorFilhoId}`)    
  },

  removerSubindicador(logicaIntervencaoId, indicadorPaiId, indicadorFilhoId) {
    const url = resource.replace(new RegExp("{logicaIntervencaoId}", "g"), logicaIntervencaoId)
    return Request.delete(`${url}/${indicadorPaiId}/subindicador/${indicadorFilhoId}`)    
  }

}
